// Week / Month schedules: today and upcoming days first; a past day only drops to the bottom once
// every game on it is complete (a late game still being played keeps its day on top).
export const pastLast = (list, dayOf, doneOf = () => true) => {
    const today = new Date().toLocaleDateString("en-CA");
    const down = (x) => dayOf(x) < today && doneOf(x);
    return [...list.filter((x) => !down(x)), ...list.filter(down)];
};
// A day is "done" once nothing on it is still being played.
export const dayDone = (games) => !(games || []).some((g) => ["LIVE", "CRIT"].includes(String(g?.gameState || "").toUpperCase()));

// PWHL times are stored like "7:00 PM EST" — turn date + time into a UTC instant.
export const pwhlUtc = (date, time) => {
    const m = /(\d{1,2}):(\d{2})\s*(AM|PM)?\s*(EST|EDT|ET|CST|CDT|MST|MDT|PST|PDT)?/i.exec(time || "");
    if (!m) return `${date}T23:00:00Z`;
    let h = Number(m[1]) % 12; if ((m[3] || "").toUpperCase() === "PM") h += 12;
    const off = { EST: 5, EDT: 4, ET: 5, CST: 6, CDT: 5, MST: 7, MDT: 6, PST: 8, PDT: 7 }[(m[4] || "ET").toUpperCase()];
    return new Date(Date.UTC(...date.split("-").map((v, i) => Number(v) - (i === 1 ? 1 : 0)), h + off, Number(m[2]))).toISOString();
};
